const RAW_EVENT_NAMES = {
  LINK_CLICK: 'link_click',
  CONTENT_VISIT: 'content_visit',
  FOLLOW: 'follow',
  PROFILE_VIEW: 'profile_view',
  TRANSACTION: 'transaction',
};

export default RAW_EVENT_NAMES;
